import * as v from 'valibot';

// Observe-only response contracts: drift here is otherwise silent.

// Prices arrive as decimal strings (`"1.600000"`); reject only what parseFloat
// turns into NaN.
const priceNumeric = v.pipe(
  v.union([v.number(), v.string()]),
  v.check(
    (value) => Number.isFinite(Number.parseFloat(String(value))),
    'expected a parseFloat-able finite price',
  ),
);

export const clusterPriceSchema = v.object({
  price: v.pipe(
    v.object({
      // Optional: the wrapped error path returns `{ code, errMsg }` with none of
      // the leaves; the check below requires them on a success body.
      code: v.optional(v.number()),
      packagePrice: v.optional(priceNumeric),
      feUnitPrice: v.optional(priceNumeric),
      beUnitPrice: v.optional(priceNumeric),
      // Instance-store VMs legitimately omit this one.
      storageUnitPrice: v.optional(priceNumeric),
    }),
    v.check(
      (price) =>
        price.code !== undefined ||
        (price.packagePrice !== undefined &&
          price.feUnitPrice !== undefined &&
          price.beUnitPrice !== undefined),
      'a success price must carry packagePrice, feUnitPrice and beUnitPrice',
    ),
  ),
});

const freeTierItemSchema = v.object({
  // Compared with `===`; a string would silently match nothing.
  resource_type: v.number(),
  vm_category_id: v.optional(v.string()),
  num: v.optional(v.number()),
});

export const freeTierListSchema = v.object({
  // PascalCase: the Go field has no json tag. Nullable, not optional: Go sends an
  // empty slice as null, while an absent key means the field was renamed.
  FreeTiers: v.nullable(v.array(v.object({ items: v.array(freeTierItemSchema) }))),
});
